export default __webpack_public_path__ + "static/media/EM1030.34I-29212_-16956_0.c8053406.jpg";